var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "main" },
    [
      _c("v-page-header", { attrs: { title: _vm.$t("mixingplants.title") } }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-container" }, [
        _c("div", { staticClass: "grid-x" }, [
          _c(
            "div",
            {
              staticClass:
                "cell medium-9 medium-offset-1 large-11 large-offset-0",
            },
            [
              _c("v-action-buttons", {
                attrs: { items: _vm.getActionButtons },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "box" },
                [
                  _c(
                    "form",
                    {
                      staticClass: "filter filter--search",
                      attrs: { action: "", method: "POST", novalidation: "" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.onFilterMixingplants.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "filter__grid" }, [
                        _c("div", { staticClass: "filter__grid__item" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.mixingplantTableFilter.companyname,
                                  expression:
                                    "mixingplantTableFilter.companyname",
                                },
                              ],
                              staticClass:
                                "form-control form-control--small form-control--search",
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("companyname"),
                              },
                              domProps: {
                                value: _vm.mixingplantTableFilter.companyname,
                              },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.mixingplantTableFilter,
                                    "companyname",
                                    $event.target.value
                                  )
                                },
                              },
                            }),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "filter__grid__item filter__grid__item--normal",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "form-group form-group--row u-no-margin--bottom",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-group--search",
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "button",
                                        attrs: {
                                          role: "button",
                                          type: "submit",
                                          title: _vm.$t("search"),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(_vm.$t("search")) +
                                            "\n                                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.resultsTableItems.length) +
                        " von " +
                        _vm._s(_vm.resultsTableItemsCount) +
                        "\n                        "
                    ),
                    _vm.resultsTableItemsCount === 1
                      ? _c("span", [_vm._v("Mischanlage")])
                      : _c("span", [_vm._v("Mischanlagen")]),
                  ]),
                  _vm._v(" "),
                  _c("v-table", {
                    attrs: {
                      isLoading: _vm.resultsTableLoading,
                      columns: _vm.resultsTableColumns,
                      items: _vm.resultsTableItems,
                      showHeaderRow: true,
                      showShowAll: true,
                      showAll: _vm.mixingplantTableFilter.show_all,
                      useDetailRow: false,
                    },
                    on: { onChangeShowAll: _vm.onChangeShowAllTableFilter },
                    scopedSlots: _vm._u([
                      {
                        key: "name",
                        fn: function ({ row }) {
                          return [
                            _c("div", { staticClass: "l-ranking-grid" }, [
                              _c(
                                "div",
                                { staticClass: "l-ranking-grid__cell" },
                                [
                                  _c("span", {
                                    class:
                                      "c-ranking c-ranking--" +
                                      (row.ranking || "none"),
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "l-ranking-grid__cell" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "table-description" },
                                    [_vm._v(" " + _vm._s(row.name))]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        },
                      },
                      {
                        key: "address",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "table-description table-description--normal",
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(row.address.street) +
                                    " " +
                                    _vm._s(row.address.housenumber) +
                                    "\n                            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "city",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "table-description table-description--normal",
                              },
                              [_vm._v(_vm._s(row.address.city))]
                            ),
                          ]
                        },
                      },
                      {
                        key: "zipcode",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "table-description table-description--normal",
                              },
                              [_vm._v(_vm._s(row.address.zipcode))]
                            ),
                          ]
                        },
                      },
                      {
                        key: "telephone",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "table-description table-description--normal",
                              },
                              [
                                _c(
                                  "a",
                                  { attrs: { href: `tel:${row.phone}` } },
                                  [_vm._v(_vm._s(row.phone))]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "email",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "table-description table-description--normal",
                              },
                              [
                                _c(
                                  "a",
                                  { attrs: { href: `mailto:${row.email}` } },
                                  [_vm._v(_vm._s(row.email))]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "link",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "button button--action button--action--edit button--small",
                                attrs: {
                                  to: {
                                    name: "view-mixingplant",
                                    params: { mixingplant: row.id },
                                  },
                                  title: _vm.$t("update"),
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("update")))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("v-ranking-legend"),
                  _vm._v(" "),
                  _c("v-pagination", {
                    attrs: {
                      currentPage: _vm.resultsTableCurrentPage,
                      itemsPerPage: _vm.resultsTableItemsPerPage,
                      items: _vm.resultsTableItemsCount,
                    },
                    on: { pageClicked: _vm.onPaginate },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }